import * as React from 'react';
import { observer } from 'mobx-react';
import { Typography } from '../../../../components/UI';
import { T } from '../../../../Translations';
import { SharedInvitationResource } from '../../SharedOpenEnrollment/SharedInvitationResourceStore/Types';

interface Props {
  sharedInvitationResource: SharedInvitationResource;
}

const PasswordInstructions: React.FC<Props> = ({ sharedInvitationResource }) => {
  switch (sharedInvitationResource.payload.kind) {
    case 'use-case':
      return (
        <Typography>
          <T kind="Enter your password to discover the Experiences available to you." />
        </Typography>
      );
    case 'use-cases-program-family':
      return (
        <Typography>
          <T kind="Enter your password to continue." />
        </Typography>
      );
    case 'preview-only':
      return <></>;
  }
};

export default observer(PasswordInstructions);
